import * as Sentry from '@sentry/react';

/**
 * Inicializa Sentry (observabilidad de errores + performance + session replay).
 * DSN y environment se inyectan por variables de entorno (dotenv-webpack).
 * Solo se activa cuando hay DSN, para no generar ruido en local sin la variable.
 * (Claves ordenadas alfabéticamente por la regla sort-keys-fix del repo.)
 */
export function initSentry(): void {
  const dsn = process.env.ENV_SENTRY_DSN;

  Sentry.init({
    dsn,
    enabled: Boolean(dsn),
    environment: process.env.ENV_ORIGIN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    // Solo mismo origen. NO agregar aqui las APIs de llavero: al propagar la
    // traza, el SDK le pega los headers `sentry-trace` y `baggage` a esas
    // peticiones, y el CORS de esas APIs no los permite en
    // Access-Control-Allow-Headers, asi que el navegador BLOQUEA la peticion
    // (se ve como "Provisional headers are shown" y sin response headers).
    // Rompia get_cognito_user_role, o sea la resolucion de roles del usuario.
    //   apiv2.llavero.co     -> Content-Type, X-Amz-Date, Authorization,
    //                           X-Api-Key, X-Amz-Security-Token,
    //                           X-Amz-User-Agent, Env-Origin
    //   api-im.llavero.co    -> Content-Type, X-Amz-Date, Authorization,
    //                           X-Api-Key, X-Amz-Security-Token
    // Para volver a habilitar el tracing distribuido hay que agregar primero
    // `sentry-trace` y `baggage` al CORS de cada API.
    tracePropagationTargets: ['localhost', /^\//],
    tracesSampleRate: 0.1,
  });
}
